/**
 * Maestro Animal — Eventos de TikTok Pixel (AddToCart)
 *
 * Escucha el mismo evento cartUpdate que ya usan el carrito y el regalo de
 * bienvenida, y solo dispara AddToCart cuando el origen es un añadido real
 * al carrito (ficha de producto o tarjeta de producto con selector de peso),
 * nunca en cambios de cantidad o al aplicar un código de descuento.
 */
(function () {
  var ADD_TO_CART_SOURCES = ['product-form', 'maestro-product-card'];

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!data || ADD_TO_CART_SOURCES.indexOf(data.source) === -1) return;
      if (typeof ttq === 'undefined') return;

      var item = data.cartData;
      if (!item || !item.variant_id) return;

      ttq.track('AddToCart', {
        contents: [
          {
            content_id: String(item.variant_id),
            content_type: 'product',
            content_name: item.product_title || item.title || '',
          },
        ],
        value: (item.price || 0) / 100,
        currency: 'EUR',
        quantity: item.quantity || 1,
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
